import React, { useEffect, useState } from "react";
import { Modal, Select, Form, Row, Col, DatePicker } from "antd";
import {
  openNotificationWithIcon,
  getDaysArray_dmy,
} from "../../../../Function";
import { DeleteItemOTApi } from "../../../../../api/getOvertime";
import { ListMemberOfTeamApi } from "../../../../../api/getTeamMember";
import Button from "antd-button-color"; //npm install antd-button-color  || https://www.npmjs.com/package/antd-button-color
import "antd-button-color/dist/css/style.css";

const { RangePicker } = DatePicker;

const ModalDeleteItem = ({
  visible,
  onCancel,
  lsTeam,
  lsMemberId,
  updateData,
}) => {
  const [form] = Form.useForm();
  const [lsMember, setLsMember] = useState([]);

  const onChangeTeam = (value) => {
    form.setFieldsValue({ member: [] });
    ListMemberOfTeamApi({ idTeam: JSON.stringify(value) }).then((res) => {
      setLsMember(res.data.filter((item) => lsMemberId.includes(item.id)));
    });
  };

  useEffect(() => {
    form.resetFields();
  }, [visible]);

  const onCancelModal = () => {
    form.resetFields();
    onCancel();
    setLsMember([]);
  };
  const onFinish = (values) => {
    DeleteItemOTApi({
      listUser: values.member,
      ngay: getDaysArray_dmy(values.ngaydangky[0]._d, values.ngaydangky[1]._d),
    })
      .then((res) => {
        if (res.data.error) {
          // const dataError = Object.entries(res.data.error).map(([key,value]) => <p>{value}</p>)
          openNotificationWithIcon("error", res.data.error);
        } else {
          updateData();
          onCancel();
          form.resetFields();
        }
      })
      .catch((err) => {
        if (err.data.error) {
          openNotificationWithIcon("error", err.data.error);
        }
      });
  };

  const tailLayout = {
    wrapperCol: { offset: 9, span: 15 },
  };

  return (
    <Modal
      visible={visible}
      onCancel={onCancelModal}
      title={"Xóa lịch tăng ca"}
      style={{ minWidth: "700px" }}
      footer={false}
    >
      <Form
        form={form}
        name="control-hooks"
        onFinish={onFinish}
        labelCol={{
          span: 5,
        }}
        wrapperCol={{
          span: 19,
        }}
        layout="horizontal"
      >
        <Row>
          <Col span={24}>
            <Form.Item
              name="team"
              label="Chọn team"
              rules={[
                { required: true, message: "Vui lòng chọn ít nhất 1 team!" },
              ]}
            >
              <Select
                mode={"multiple"}
                allowClear
                dropdownStyle={{ borderRadius: 10, width: "100%" }}
                placeholder="Chọn team"
                onChange={onChangeTeam}
                maxTagCount={2}
                dropdownRender={(menu) => (
                  <div style={{ padding: 5, marginLeft: 10 }}>
                    {form.getFieldValue("team") &&
                    form.getFieldValue("team").length > 0 ? (
                      <span
                        className={"text-primary"}
                        onClick={() => {
                          form.setFieldsValue({ team: [] });
                          onChangeTeam([]);
                        }}
                      >
                        Bỏ chọn tất cả
                      </span>
                    ) : (
                      <span
                        className={"text-primary"}
                        onClick={() => {
                          form.setFieldsValue({
                            team: lsTeam.map((item) => item.idTeam),
                          });
                          onChangeTeam(lsTeam.map((item) => item.idTeam));
                        }}
                      >
                        Chọn tất cả
                      </span>
                    )}
                    {menu}
                  </div>
                )}
              >
                {lsTeam.map((item, index) => (
                  <Select.Option key={index + item.idTeam} value={item.idTeam}>
                    {item.team}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="member"
              label="Chọn nhân viên"
              rules={[
                {
                  required: true,
                  message: "Vui lòng chọn ít nhất 1 nhân viên!",
                },
              ]}
            >
              <Select
                mode={"multiple"}
                allowClear
                dropdownStyle={{ borderRadius: 10, width: "100%" }}
                placeholder="Chọn nhân viên"
                maxTagCount={2}
                dropdownRender={(menu) => (
                  <div style={{ padding: 5, marginLeft: 10 }}>
                    {form.getFieldValue("member") &&
                    form.getFieldValue("member").length > 0 ? (
                      <span
                        className={"text-primary"}
                        onClick={() => form.setFieldsValue({ member: [] })}
                      >
                        Bỏ chọn tất cả
                      </span>
                    ) : (
                      <span
                        className={"text-primary"}
                        onClick={() =>
                          form.setFieldsValue({
                            member: lsMember.map((item) => item.id),
                          })
                        }
                      >
                        Chọn tất cả
                      </span>
                    )}
                    {menu}
                  </div>
                )}
              >
                {lsMember.map((item, index) => (
                  <Select.Option
                    key={index + item.id + item.username}
                    value={item.id}
                  >
                    {item.username}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="Ngày đăng ký"
              name="ngaydangky"
              rules={[{ required: true }]}
            >
              <RangePicker
                format={"DD/MM/YYYY"}
                allowClear={false}
                style={{ borderRadius: 10 }}
              />
            </Form.Item>
            <Form.Item {...tailLayout}>
              <Button
                style={{ marginRight: 10 }}
                type="primary"
                htmlType="submit"
              >
                Xóa đăng ký
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default ModalDeleteItem;
